import React, { useRef, useState } from "react";
import { Expand } from "lucide-react";

const ZOOM = 2.4;
const LENS = 190;
const PAD = 12;

// Magnifier for product photos — hover lens on desktop; click / tap opens the full-screen viewer
export const ZoomImage = ({ src, alt, onOpen }) => {
  const boxRef = useRef(null);
  const movedRef = useRef(false);
  const coarse = typeof window !== "undefined" && window.matchMedia?.("(pointer: coarse)").matches;
  const [lens, setLens] = useState(null);

  const onMouseMove = (e) => {
    if (coarse || !boxRef.current) return;
    const r = boxRef.current.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    if (x < 0 || y < 0 || x > r.width || y > r.height) {
      setLens(null);
      return;
    }
    setLens({ x, y, w: r.width, h: r.height });
  };

  return (
    <div
      ref={boxRef}
      className="relative aspect-square flex items-center justify-center overflow-hidden select-none"
      style={{ cursor: "zoom-in", touchAction: "auto" }}
      onMouseMove={onMouseMove}
      onMouseLeave={() => setLens(null)}
      onClick={() => { if (!coarse) onOpen?.(); }}
      onTouchStart={() => { movedRef.current = false; }}
      onTouchMove={() => { movedRef.current = true; }}
      onTouchEnd={() => { if (!movedRef.current) onOpen?.(); }}
      data-testid="product-zoom-image"
    >
      <img
        src={src}
        alt={alt}
        draggable={false}
        className="w-full h-full object-contain p-3"
      />
      {lens && !coarse && (
        <div
          className="absolute rounded-full border-2 border-[#c9a24b] shadow-[0_10px_30px_-10px_rgba(26,23,19,0.5)] overflow-hidden bg-white pointer-events-none z-10"
          style={{ width: LENS, height: LENS, left: lens.x - LENS / 2, top: lens.y - LENS / 2 }}
          data-testid="zoom-lens"
        >
          <img
            src={src}
            alt=""
            aria-hidden="true"
            draggable={false}
            className="object-contain max-w-none"
            style={{
              width: lens.w * ZOOM,
              height: lens.h * ZOOM,
              padding: PAD * ZOOM,
              marginLeft: -(lens.x * ZOOM - LENS / 2),
              marginTop: -(lens.y * ZOOM - LENS / 2),
            }}
          />
        </div>
      )}
      <span
        className="absolute bottom-2 right-2 flex items-center gap-1 text-[10px] tracking-[0.12em] uppercase px-2 py-1 bg-white/85 text-[#8a6a1f] border border-[#e2d7bd] pointer-events-none opacity-80"
        data-testid="zoom-hint"
      >
        <Expand size={11} /> {coarse ? "Tap to enlarge" : "Click to enlarge"}
      </span>
    </div>
  );
};
